export type PointRedeemErrorCode =
  | "pointRedeemInsufficient"
  | "pointRedeemMaxPerOrderExceeded"
  | "pointRedeemMaxPerUserExceeded";

const pointRedeemErrorCodes: PointRedeemErrorCode[] = [
  "pointRedeemInsufficient",
  "pointRedeemMaxPerOrderExceeded",
  "pointRedeemMaxPerUserExceeded",
];

export function parsePointRedeemError(error: unknown): PointRedeemErrorCode | undefined {
  if (!error || !(error instanceof Error)) return undefined;

  return pointRedeemErrorCodes.find((code) => error.message.includes(code));
}

import productCore from "./product.core";
import { CartItem } from "../types/cart";

export function isCartItemPointRedeemed(item: Pick<CartItem, "isPointRedeemed" | "product">): boolean {
  return !!item.isPointRedeemed && productCore.isPointRedeemable(item.product);
}

export function sumCartCashSubtotal(items: Pick<CartItem, "isPointRedeemed" | "product" | "itemTotal">[]): number {
  return items.reduce((sum, item) => {
    if (isCartItemPointRedeemed(item)) return sum;
    return sum + (item.itemTotal ?? 0);
  }, 0);
}

export function getPointCostForCartItem(product: { pointRedemption?: { pointCost?: number } }, quantity: number): number {
  return (product.pointRedemption?.pointCost ?? 0) * quantity;
}

export function getCartItemMaxQuantity(
  item: Pick<CartItem, "isPointRedeemed" | "product" | "maxQuantity" | "addOnDiscount">,
  inventory: number | undefined,
): number | undefined {
  if (item.addOnDiscount) {
    return item.maxQuantity;
  }

  const maxPerOrder = isCartItemPointRedeemed(item) ? item.product.pointRedemption?.maxPerOrder : undefined;

  if (inventory === undefined) {
    return maxPerOrder;
  }

  if (maxPerOrder !== undefined) {
    return Math.min(inventory, maxPerOrder);
  }

  return inventory;
}
